/**
 * Zeichen der App, von Hand gezeichnet.
 *
 * Keine Bibliothek und keine Datei aus dem Netz: vier kleine Formen, die zeigen, worum es
 * im jeweiligen Block geht. Sie nehmen die Farbe der Umgebung (`currentColor`) und die
 * Farben der Lichter aus den Marken, damit sie in Nacht, Tag und Rot stimmen.
 */

export function MarkeIcon() {
  return (
    <svg className="shell__mark" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <circle cx="12" cy="5" r="2.4" fill="var(--licht-weiss)" />
      <circle cx="5" cy="13" r="2.2" fill="var(--licht-rot)" />
      <circle cx="19" cy="13" r="2.2" fill="var(--licht-gruen)" />
      <path d="M3 19h18l-2.5 3H5.5z" fill="currentColor" opacity="0.55" />
    </svg>
  )
}

export function LichterIcon() {
  return (
    <svg viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <path d="M8 21h12l-2 4H10z" fill="currentColor" opacity="0.5" />
      <path d="M14 5v12" stroke="currentColor" strokeWidth="1.5" opacity="0.6" />
      <circle cx="14" cy="4" r="2.6" fill="var(--licht-weiss)" />
      <circle cx="7" cy="17" r="2.2" fill="var(--licht-rot)" />
      <circle cx="21" cy="17" r="2.2" fill="var(--licht-gruen)" />
    </svg>
  )
}

export function SeezeichenIcon() {
  return (
    <svg viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <path d="M11 24h6l-1.4-9h-3.2z" fill="currentColor" opacity="0.55" />
      <rect x="12.6" y="7" width="2.8" height="9" fill="currentColor" opacity="0.45" />
      <path d="M14 2l4 5h-8z" fill="var(--licht-gelb)" />
      <circle cx="14" cy="9.5" r="1.6" fill="var(--licht-gelb)" />
    </svg>
  )
}

export function AusweichenIcon() {
  return (
    <svg viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <path d="M3 18h9l-1.6 3.4H4.6z" fill="currentColor" opacity="0.55" />
      <path d="M16 7h9l-1.6 3.4H17.6z" fill="currentColor" opacity="0.4" />
      <path d="M12 16.5L19 11" stroke="var(--licht-rot)" strokeWidth="1.6" strokeDasharray="2 2" />
      <circle cx="12.6" cy="16.2" r="1.7" fill="var(--licht-gruen)" />
      <circle cx="18.6" cy="11.2" r="1.7" fill="var(--licht-rot)" />
    </svg>
  )
}

export function SignaleIcon() {
  return (
    <svg viewBox="0 0 28 28" fill="none" aria-hidden="true">
      <path d="M5 11h5l6-4v14l-6-4H5z" fill="currentColor" opacity="0.55" />
      <path d="M19 9.5a6 6 0 010 9" stroke="var(--licht-gelb)" strokeWidth="1.6" strokeLinecap="round" />
      <path d="M22.5 6.5a10 10 0 010 15" stroke="var(--licht-gelb)" strokeWidth="1.4" strokeLinecap="round" opacity="0.6" />
    </svg>
  )
}
